/* eslint-disable no-plusplus */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import EndPoints from '../Routes/EndPoints';
import { Empty } from '../Screens/ScreenAddSmc/Utils/TypeSmc';
import { CUSTOMER_ID } from '../Screens/addCustomer/utils/constants';
import StorageUtils from './StorageUtils';

dayjs.extend(utc);
dayjs.extend(timezone);

export const getZoneTime = (stamp: string) => {
  if (stamp === '') return '';
  const systemTZ = dayjs.tz.guess();
  const localDateTime = dayjs
    .utc(stamp)
    .tz(systemTZ);
  return localDateTime.format('MM/DD/YYYY hh:mm A');
};

export const getEasternTime = (stamp: string) => {
  if (stamp === '') return '';

  return dayjs
    .utc(stamp)
    .tz('America/New_York')
    .format('MM/DD/YYYY hh:mm A');
};

export const getDateTime = (stamp: string) => {
  if (stamp === '') return '';
  const localDateTime = dayjs
    .utc(stamp);
  return localDateTime.format('MM-DD-YYYY hh:mm A');
};

export const handleCustomerId = (path:string) => {
  if (!path?.includes(EndPoints.ADD_CUSTOMER)) {
    StorageUtils.removeString(CUSTOMER_ID);
  }
};

export function convertDateFormat(dateStr:string) {
  if (!dateStr) return dateStr;
  const [day, month, year] = dateStr.split('-');

  const newDateStr = `${month}-${day}-${year}`;
  if (day && month && year) {
    return newDateStr;
  }
  return dateStr || '';
}

export function convertDateFormatDDMMYYYY(dateStr:string) {
  if (!dateStr) return dateStr;
  const [month, day, year] = dateStr.split('-');

  const newDateStr = `${day}-${month}-${year}`;
  return newDateStr;
}

export const getItemIndex = (page: number, rowsPerPage: number, index: number) => (page - 1) * (rowsPerPage) + (index) + 1;

export const scrollToErrorField = (fieldId:string) => {
  const fieldRef = document.getElementById(fieldId);
  if (fieldRef) {
    fieldRef.scrollIntoView({ behavior: 'smooth' });
  }
};

export function capitalizeFirstLetter(inputString: string) {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
}

export function getTotalDaysInMonth(year: number, month:number) {
  const date = new Date(year, month - 1, 1);

  date.setMonth(date.getMonth() + 1);
  date.setDate(date.getDate() - 1);

  return date.getDate();
}

export function generateRandomId(length = 8) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomId = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomId += characters.charAt(randomIndex);
  }

  return randomId;
}

export function convertDate(dateString: string) {
  const parts = dateString.split('-');
  const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
  return new Date(formattedDate);
}

export function convertText(originalText: string) {
  const convertedText = originalText?.toLowerCase()?.replace(/(?:^|\s)\S/g, (match) => match?.toUpperCase());
  return convertedText;
}

const removeHtmlTags = (input: Empty) => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = input;
  return tempElement.textContent || tempElement.innerText || '';
};

export const processData = (data: Empty) => data?.map((item: Empty) => ({
  ...item,
  Description: removeHtmlTags(item?.Description),
}));

export function formatDateString(dateString: string) {
  if (!dateString) {
    return '';
  }
  const datePart = dateString.split('T')[0];

  const date = new Date(datePart);

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(date.getTime())) {
    return '';
  }

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
}

export function convertDateFormatTo(dateStr:string) {
  if (!dateStr) return dateStr;
  const [day, month, year] = dateStr.split('-');

  const newDateStr = `${month}/${day}/${year}`;
  return newDateStr;
}
export function formatDateToMMDDYY(dateStr:string) {
  if (!dateStr) return dateStr;
  const [day, month, year] = dateStr.split('-');

  const newDateStr = `${month}-${day}-${year}`;
  return newDateStr;
}

export function convertDateRangeToMMDDYYYY(dateRangeStr: string): string {
  const [startDate, endDate] = dateRangeStr.split(' TO ');
  const convertToMMDDYYYY = (dateStr: string): string => {
    const [day, month, year] = dateStr?.split('-') || '';
    return (month && day && year) ? `${month}-${day}-${year}` : '';
  };
  const convertedStartDate = convertToMMDDYYYY(startDate);
  const convertedEndDate = convertToMMDDYYYY(endDate);
  return (convertedStartDate?.length > 0 || convertedEndDate?.length > 0) ? `${convertedStartDate} TO ${convertedEndDate}` : '';
}

export function convertDateInString(dateStr: string): string {
  const regex = /(\d{2})-(\d{2})-(\d{4})/;
  const match = dateStr.match(regex);

  if (match) {
    const [day, month, year] = match[0].split('-');
    const formattedDate = `${month}-${day}-${year}`;
    return dateStr.replace(regex, formattedDate);
  }
  return dateStr; // return original string if no date is found
}

export function RemoveHtmlTags(str: string) {
  return str?.replace(/<\/?p>/gi, '');
}

export const toRoman = (num: number): string => {
  const romanNumerals: [string, number][] = [
    ['M', 1000],
    ['CM', 900],
    ['D', 500],
    ['CD', 400],
    ['C', 100],
    ['XC', 90],
    ['L', 50],
    ['XL', 40],
    ['X', 10],
    ['IX', 9],
    ['V', 5],
    ['IV', 4],
    ['I', 1],
  ];

  let result = '';
  let remainingNum = num; // Create a local variable to hold the value of num

  romanNumerals.forEach(([roman, value]) => {
    while (remainingNum >= value) {
      result += roman;
      remainingNum -= value;
    }
  });

  return result;
};

export function stripCustPrefix(input: string, prefix = 'Cust-'): string {
  if (input?.startsWith(prefix)) {
    return input.slice(prefix?.length);
  }
  return input;
}

export function formatDate(dateStr: string) {
  if (!dateStr) {
    return dateStr;
  }
  // Split the input string by '/'
  const [month, day, year] = dateStr.split('/');

  // Return the formatted date in YYYY-MM-DD format
  return `${month}-${day}-${year}`;
}

// export function gaugeToInch(gauge : string) {
//   // Constant factors for steel gauge conversion
//   const baseThickness = 0.005;
//   const factor = 92;
//   const offset = 36;
//   const scale = 39;

//   // Calculate thickness in inches using the exponentiation operator
//   const thickness = Number(baseThickness * (factor ** ((offset - Number(gauge)) / scale)));
//   return String(thickness.toFixed(3));
// }
export function gaugeToInch(gauge : string, pay?: boolean) {
  switch (gauge) {
    case '00': return '.380';
    case '0': return '.340';
    case '1': return '.300';
    case '2': return '.284';
    case '3': return '.259';
    case '4': return '.238';
    case '5': return '.220';
    case '6': return '.203';
    case '7': return '.180';
    case '8': return '.165';
    case '9': return '.148';
    case '10': return '.134';
    case '11': return '.120';
    case '12': return '.109';
    case '13': return '.095';
    case '14': return '.083';
    case '15': return '.072';
    case '16': return '.065';
    case '17': return '.058';
    case '18': return '.049';
    case '19': return '.042';
    case '20': return '.035';
    case '21': return '.032';
    case '22': return '.028';
    case '23': return '.025';
    case '24': return '.022';
    default: if (pay === true) {
      return '';
    } return `Can't convert Gauge ${gauge}`;
  }
}

// Helper to wait for all images inside an element
export const waitForAllImagesToLoad = (container: HTMLElement): Promise<void> => {
  const images = Array.from(container.querySelectorAll('img'));
  const loadPromises = images.map((img) => {
    if (img.complete && img.naturalHeight !== 0) {
      return Promise.resolve();
    }
    return new Promise<void>((resolve) => {
      const onLoadOrError = () => {
        img.removeEventListener('load', onLoadOrError);
        img.removeEventListener('error', onLoadOrError);
        resolve();
      };
      img.addEventListener('load', onLoadOrError);
      img.addEventListener('error', onLoadOrError);
    });
  });

  return Promise.all(loadPromises).then(() => undefined);
};

export const getTestName = (testType: string) => {
  switch (testType) {
    case 'ECT': return 'Cross/Diff';
    case 'FLT': return 'Flux';
    case 'ADT': return 'Abs/Diff';
    default: return '';
  }
};

export const getBase64FromImageUrl = (url: string): Promise<string> => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = 'Anonymous';

  // eslint-disable-next-line consistent-return
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    if (!ctx) return reject(new Error('Canvas context not available'));

    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL('image/png');
    resolve(dataURL);
  };

  img.onerror = () => reject(new Error('Failed to load image'));

  img.src = url;
});

export function formatPriceWithCommas(amount: string): string {
  if (!amount) return '';

  // Remove everything except digits and dot
  const cleaned = amount.replace(/[^\d.]/g, '');

  // Split integer and decimal parts
  const [integerPart, decimalPart] = cleaned.split('.');

  // Format integer part with commas
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Return with decimal part if exists
  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
}

export const getTextColorAsPerBackground = (backgroundColor: string): 'black' | 'white' => {
  // Remove #
  const hex = backgroundColor.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Perceived brightness
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness > 128 ? 'black' : 'white';
};
